import script from "./AddCatalogModalBulkOperations.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCatalogModalBulkOperations.vue?vue&type=script&setup=true&lang=js"

import "./AddCatalogModalBulkOperations.vue?vue&type=style&index=0&id=a17bd474&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a17bd474"]])

export default __exports__